module.exports = __webpack_public_path__ + "img/12.237d17f4.png";